<h2 mat-dialog-title>{{ 'INBOX.TERMS_OF_SERVICE.FULL_TITLE' | translate }}</h2>
<ng-container *ngIf="!showFullTOS; else fullTOS">
  <mat-dialog-content class="first-tos-content">
    <section>
      {{ 'INBOX.TERMS_OF_SERVICE.INTRO_FIRST_LINE' | translate }}
      <a (click)="toggleTOS()">{{ 'INBOX.TERMS_OF_SERVICE.TITLE' | translate }}.</a>
    </section>

    <mat-checkbox [(ngModel)]="checkedTerms">
      {{ 'INBOX.TERMS_OF_SERVICE.ACCEPTANCE_MESSAGE' | translate }}
    </mat-checkbox>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>{{ 'INBOX.COMMON.ACTION_LABELS.DECLINE' | translate }}</button>
    <button mat-flat-button color="primary" [disabled]="!checkedTerms" (click)="accepts(checkedTerms)" mat-dialog-close>
      {{ 'INBOX.COMMON.ACTION_LABELS.AGREE' | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #fullTOS>
  <mat-dialog-content>
    <div [innerHTML]="data?.termsOfService | sanitize"></div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button (click)="toggleTOS()">{{ 'INBOX.COMMON.ACTION_LABELS.GO_BACK' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
